'use strict';

var markdown = require("markdown");

angular.module('dokiv')
  .filter('markdown', ['$sanitize', function($sanitize) {
    return function(text) {
      if(text) {
        return $sanitize(markdown.markdown.toHTML(String(text)));
      }
      else {
        return "";
      }
    };
  }]);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/MarkdownFilter.js
// module id = 247
// module chunks = 0